module.exports = __webpack_public_path__ + "static/media/Trade_Trade_2.45337be4.png";